const initialState = {
  haulList: [],
  loading: true
}

export default initialState
